import { useState } from "react";
import PagePadding from "../layouts/PagePadding";
import Products from "../components/communities/Products";
import SortBy from "../components/sort-by/SortBy";

const Communities = () => {
  const [uiOnScreen, setUiOnScreen] = useState("explore");

  return (
    <div className="relative min-h-screen pb-5 md:pb-36">
      <PagePadding>
        <p className="pt-2 text-sm text-label">
          Home /<span className="text-black"> Communities</span>
        </p>
      </PagePadding>

      <div className="mt-5 text-center border-b border-label">
        <h3 className="font-bold text-2xl lg:text-3xl">Communities</h3>
        <div className="mt-5 flex gap-10 justify-center">
          <button
            className={`pt-3 pr-3 pl-3 pb-1 ${
              uiOnScreen === "explore"
                ? "border-b border-logoRed text-black font-bold"
                : "text-label"
            } text-sm`}
            onClick={() => setUiOnScreen("explore")}
          >
            Explore all
          </button>
          <button
            className={`pt-3 pr-3 pl-3 pb-1 ${
              uiOnScreen === "following"
                ? "border-b border-logoRed text-black font-bold"
                : "text-label"
            } text-sm`}
            onClick={() => setUiOnScreen("following")}
          >
            Following (0)
          </button>
        </div>
      </div>

      <PagePadding>
        <SortBy margin="mt-5" />

        <section className="flex justify-center">
          <div className="w-full lg:w-2/3">
            <Products />
          </div>
        </section>
      </PagePadding>
    </div>
  );
};

export default Communities;
